/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get('pagination')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id=' + id + ']');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.i = 2;
    }
    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
    addUrlParam(search, key) {
      var newParam = key + '=' + this.i,
        params = '?' + newParam;

      // If the "search" string exists, then build params from it
      if (search) {
        // Try to replace an existance instance
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);

        // If nothing was replaced, then add the new param to the end
        if (params === search) {
          params += '&' + newParam;
        }
      }

      return params;
    }
    loadMore() {
      let base = this;
      this.button.addEventListener('click', function () {
        base.loadProducts();
        this.blur();
        return false;
      });
    }
    infinite() {
      let base = this;
      // isIntersecting (non "=== 1"): su desktop/Chrome il sentinello può restare
      // visibile dopo l'append senza riattraversare la soglia, e l'osservatore non
      // riemetteva piu' (blocco al 2° caricamento). rootMargin pre-carica in anticipo.
      base.observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          base.loadProducts();
        }
      }, {
        rootMargin: '600px 0px 600px 0px'
      });
      base.observer.observe(base);
    }
    loadProducts() {
      let base = this,
        url = document.location.pathname + base.addUrlParam(document.location.search, 'page');
      if (base.getAttribute('loading')) {
        return;
      }
      base.i++;
      base.setAttribute('loading', true);
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          base.renderProducts(html, url);

          dispatchCustomEvent('pagination:page-changed', {
            url: url
          });
        });
    }
    renderProducts(html, url) {
      let base = this,
        grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid'),
        products = grid_to_replace ? grid_to_replace.querySelectorAll('.column') : [];

      // Fine della collezione. Oltre l'ultima pagina Shopify rende comunque
      // #product-grid (vuoto, col messaggio "nessun prodotto"): fermarsi solo
      // se la griglia manca non basta, e con reobserve() si chiederebbero
      // pagine all'infinito finche' il sentinello resta in vista.
      if (!products.length) {
        if (base.observer) {
          base.observer.disconnect();
        }
        base.removeAttribute('loading');
        if (base.button) {
          base.button.classList.add('visually-hidden');
        }
        return;
      }

      for (var i = 0; i < products.length; i++) {
        this.grid.appendChild(products[i]);
      }
      if (this.animations_enabled) {
        gsap.set(products, {
          opacity: 0,
          y: 30
        });
        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05,
          onComplete: function () {
            base.removeAttribute('loading');
            base.reobserve();
            base.stampedBadges();
          }
        });
      } else {
        base.removeAttribute('loading');
        base.reobserve();
        base.stampedBadges();
      }
    }
    // Sul negozio StampedFn non esiste (verificato il 30/09/2026): il vecchio
    // controllo typeof StampedFn.loadBadges leggeva una variabile non dichiarata
    // e lanciava un ReferenceError a ogni caricamento.
    stampedBadges() {
      if (typeof StampedFn !== 'undefined' && typeof StampedFn.loadBadges === 'function') {
        StampedFn.loadBadges();
      }
    }
    // Riaggancia l'osservatore dopo ogni caricamento: forza una nuova valutazione
    // dell'intersezione, cosi' se il sentinello e' ancora in vista (viewport alta su
    // desktop) carica la pagina successiva invece di bloccarsi.
    reobserve() {
      if (this.observer) {
        this.observer.unobserve(this);
        this.observer.observe(this);
      }
    }
  }
  customElements.define('pagination-theme', Pagination);
}